import React from "react";
import { Link } from "react-router-dom";
import { CHOOSE_PLAN_PATH } from "../../shared/_helpers/chatGate";
import StarsIcon from "../../styles/StarsIcon";
import { Panel } from "../ui";
import { cn } from "../ui/cn";

// An overlay for the card it sits in (the card is `tw-relative tw-overflow-hidden`):
// what is behind it is blurred, so sample figures never read as real data.
const NonSubLockBox = ({ className }) => {
    return (
        <Link
            to={CHOOSE_PLAN_PATH}
            className={cn(
                "tw-absolute tw-inset-0 tw-z-10 tw-grid tw-place-items-center tw-bg-overlay-navy/30 tw-p-3 tw-no-underline tw-backdrop-blur-sm hover:tw-text-text",
                className,
            )}
        >
            <Panel className="tw-text-center tw-shadow-2 tw-p-3 max-rail:tw-p-3">
                <StarsIcon name="lock" className="tw-mx-auto tw-h-6 tw-w-6 tw-text-text-muted" />
                <h2 className="tw-m-0 tw-mt-1 tw-flex tw-items-center tw-justify-center tw-gap-2 tw-text-md tw-font-bold tw-text-text">
                    Get Full Access
                    <StarsIcon name="arrow" className="tw-h-4 tw-w-4 tw-shrink-0" />
                </h2>
                <p className="tw-m-0 tw-mt-1 tw-text-xs tw-text-text-muted">Unlock full access to all features and content instantly.</p>
            </Panel>
        </Link>
    );
};

export default NonSubLockBox;
